import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import Form from "../../components/Form/Form";
import useForm from "../../components/Form/useForm";
import Button from '@mui/material/Button';
import Notification from "../../components/Notification/Notification";
import Spinner from "../../components/Spinner/Spinner";
import { amplify } from "../../service/api/AuthService";
import { lengthValidator } from "../../utils/validators";
import { createNotifyError } from "../../utils/helpers";
import "./UserConfirmationPage.scss";
import LogoIcon from "../../assets/icons/LogoIcon";
import PdfImage from "../../assets/backgrounds/pdf-image.png";
import { ModalBody } from "react-bootstrap";
import { Accordion, AccordionDetails, AccordionSummary, TextField } from "@mui/material";
import Modal from 'react-bootstrap/Modal';
import LoginCarousel from "../../components/LoginCarousel/LoginCarousel";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from "../../assets/icons/CheckIcon"



const fields = [
  {
    field: "userName",
    headerName: "User Name",
    validation: (text) => lengthValidator(text, 1, 50, true),
  },
  {
    field: "userCode",
    headerName: "Confirmation Code",
    validation: (text) => lengthValidator(text, 1, 50, true),
  },
];

const initialValues = Object.assign(...fields.map((x) => ({ [x.field]: "" })));

const UserConfirmationPage = ({ setUser, ...props }) => {
  const { history } = props;
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [notification, setNotification] = useState(undefined);
  const [modalOpen, setModalOpen] = useState(false);


  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    fields.forEach((value) => {
      if (value.field in fieldValues && value.validation)
        temp[value.field] = value.validation(fieldValues[value.field]);
    });
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
  const { handleInputChange } = useForm(
    initialValues,
    validate,
    true,
    null,
    values,
    setValues,
    errors,
    setErrors
  );

  useEffect(() => {
    return () => {
      window.removeEventListener("mousemove", () => { });
    };
  }, []);

  const onVerify = () => {
    if (validate()) {
      setLoading(true);
      const { userName, userCode } = values;
      amplify
        .confirmSignUp(userName, userCode)
        .then(() => {
          setModalOpen(true);
        })
        .catch(({ code }) => {
          console.log("error", code);
          setNotification(createNotifyError(code))
        }
        )
        .finally(() => setLoading(false));
    }
  };

  const goToLogin = () => {
    return history.push({
      pathname: `/login`,
    });
  };


  return (
    <div className="main-page-user">
      {notification && (
        <Notification
          notification={notification}
          setNotification={setNotification}
        />
      )}
      <div>
        <div className="row">
          <div className="col-sm-5 col-xl-5"><LogoIcon fill={"#5c157d"} className="login-body-container-logo-mobile" /></div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 left-side" style={{ minHeight: "100vh", position: "relative" }}>
            <div className="col-sm-5 col-xl-5">
              <Link to="/login">
                <LogoIcon fill={"#5c157d"} className="login-body-container-logo" />
              </Link>
            </div>
            <div className="row mt-4 pb-3">
              <div className="col-sm-5 col-xl-5">
                <h1 className="login-body-container-welcome-solunion">
                  ¡Bienvenido!<br></br>
                  Accede y descubre la
                  forma más rápida de
                  conocer a tus socios
                  comerciales.
                </h1>
                <div className="login-body-container-video">
                  <h5>Te contamos más sobre <br></br> el servicio <strong>eGrade</strong></h5>
                  <div>
                    <img className="pdf-image" alt="pdf-info" src={PdfImage} onClick={handleShow} />
                  </div>
                  <Modal show={show} size="lg">
                    <Button className="row text-end pt-1" onClick={handleClose}>
                      <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                      </svg></span>
                    </Button>
                    <ModalBody>
                      <LoginCarousel />
                    </ModalBody>
                  </Modal>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-12 col-sm-12 row col-md-12 col-lg-4 col-xl-3 right-side"
          >
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  pe-md-4 pe-sm-5 hazte-cliente">
            </div>
            <div className="container  col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 justify-content-start form-container">

              <h2 className="text-start fs-1 d-flex d-inline mb-2 pt-4">
                Confirmación de usuario
              </h2>
              <Form onSubmit={onVerify} values={values}>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-inline login-body-container-textField">
                  <TextField
                    className="username-input"
                    name="userName"
                    label="Email"
                    placeholder="Email"
                    autoComplete="username"
                    value={values.userName}
                    error={errors.userName != null && errors.userName !== ''}
                    onChange={handleInputChange}

                  />
                  <TextField
                    className="username-input-code"
                    name="userCode"
                    label="Código de verificación"
                    placeholder="Código de verificación"
                    value={values.userCode}
                    error={errors.userCode != null && errors.userCode !== ''}
                    onChange={handleInputChange}

                  />

                  <div className="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mt-0 me-5 d-flex d-inline">
                    <Button
                      sx={{ borderRadius: '2px', textTransform: "none" }}
                      type="submit"
                      disabled={loading || !values.userName || values.userName.length === 0 || !values.userCode || values.userCode.length === 0}
                      className="button-login"
                    >
                      {loading ? <><Spinner /> Cargando</> : "Enviar"}
                    </Button>
                  </div>
                  <div className="pt-4">
                    <Accordion >
                      <AccordionSummary
                        disableGutters={true}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      ><span className="comfirm-help-title"><ExpandMoreIcon />
                          ¿Necesitas ayuda?</span>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="comfirm-help-text">
                          Hemos enviado a tu email las instrucciones para poder confirmar el usuario,
                          si no lo has recibido, comprueba la carpeta
                          de <span className="comfirm-help-text-purple">correo no deseado</span> o
                          de <span className="comfirm-help-text-purple">spam</span> y verifica que
                          la dirección de correo electrónico introducida es correcta.
                        </p>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </Form>
            </div>
            <Modal className="creation-confirm-modal" show={modalOpen} onHide={goToLogin} size="lg">
              <Modal.Header closeButton style={{ border: "0px" }}>
              </Modal.Header>
              <Modal.Body>
                <div className="row justify-content-center">
                  <div className="text-center mt-3 pt-2">
                    <CheckIcon />
                  </div>
                  <div>
                    <h2 className="text-center mt-3 font-weight-light">¡Enhorabuena!</h2>
                  </div>
                  <div className="text-center mt-0">
                    <p>Tu usuario ha sido confirmado con éxito.</p>
                  </div>
                  <div className="col-xl-4 mb-5 pb-4">
                    <Button sx={{ textTransform: "none" }} className="go-to-login-btn" onClick={goToLogin}>
                      Acceder
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(UserConfirmationPage);